/**
 * MediaUrlDTO entity class
 */

/**
 * MediaUrlDTOFactory
 * returns MediaUrlDTO entity class
 *
 * @class MediaUrlDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.MediaUrlDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:MediaUrlDTOFactory
 */
/* @ngInject */
export default function MediaUrlDTOFactory (Entity) {
  /* === MediaUrlDTO class === */

  /**
   * MediaUrlDTO model
   *
   * @class MediaUrlDTO
   * @classdesc MediaUrlDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.MediaUrlDTO} MediaUrlDTO entity
   */
  function MediaUrlDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  MediaUrlDTO.prototype = Object.create(Entity.prototype)
  MediaUrlDTO.prototype.constructor = MediaUrlDTO

  /* === MediaUrlDTO instance methods & fields === */

  Object.assign(MediaUrlDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.MediaUrlDTO#
     * @type {Object}
     */
    _fields: {
      id: Number,
      $extchecked: Boolean,
      mediaUrl: String,
      playbackTokenGenerator: 'PlaybackTokenGenerator',
      playbackTokenGeneratorId: Number,
      trailerUrl: String,
      contentId: String,
      kek: String,
      drmProfiles: ['DRMProfile'],
      drm: {
        entitlementPolicyId: String,
        bundleId: String
      },
      entitlementPolicyId: String,
      bundleId: String,
      $drmType: String
    },

    /**
     * Get underlying object
     *
     * @memberof models.MediaUrlDTO#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      var ret = Entity.prototype._object.apply(this, arguments)
      if (!ret.drmProfiles || ret.drmProfiles.length === 0) {
        ret.contentId = null
      }
      return ret
    }

  })

  /* === MediaUrlDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(MediaUrlDTO, Entity)
  MediaUrlDTO._name = 'MediaUrlDTO'
  MediaUrlDTO.init()

  return MediaUrlDTO
}
